var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isDesktopChannel
      ? _c(
          "div",
          {
            staticClass:
              "leo-row leo-hidden tablet:leo-flex leo-w-screen leo-shadow-4",
          },
          [_vm._m(0)]
        )
      : _vm._e(),
    !_vm.isDesktopChannel
      ? _c(
          "div",
          { staticClass: "leo-row leo-hidden tablet:leo-flex leo-w-screen" },
          [_vm._m(1)]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "leo-col leo-px-7xl leo-py-xl leo-bg-white leo-flex",
        staticStyle: { height: "74px", "align-items": "center" },
      },
      [
        _c("img", {
          attrs: { src: require("./../../../assets/images/logo.svg"), alt: "" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "leo-col leo-px-3xl" }, [
      _c("header", { staticClass: "leo-mt-3xl" }, [
        _c(
          "div",
          { staticClass: "leo-logo", attrs: { "data-type": "master-logo" } },
          [
            _c("img", {
              attrs: {
                src: require("./../../../assets/images/3-1.svg"),
                alt: "",
              },
            }),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }